module.exports = __webpack_public_path__ + "static/img/buy_gongshi_active.49550931.png";